import { ChargingSession, ChargingSessionState } from './../types/chargingSession';

export function consumedKwh(session: ChargingSession): string {
    // in progress session use kwh in meterValues, for all other states we need to format values
    if (session.state && session.state === ChargingSessionState.InProgress) {
        return session.consumedWh ? session.consumedWh.toFixed(2) : '0.00'
    } else {
        return session.consumedWh ? (session.consumedWh / 1000).toFixed(2) : '0.00'
    }
}
export function importedKwh(session: ChargingSession): string {
    return session.importedWh ? session.importedWh.toFixed(1) : '0.0'
}
export function offeredKwh(session: ChargingSession): string {
    return session.offeredWh ? session.offeredWh.toFixed(1) : '0.0'
}
export function priceForCharging(session: ChargingSession): number {
    let consumedKwh = 0
    let parkingTime = 0
    let chargingPrice = 0
    let parkingPrice = 0

    const pricing = session.pricingCondition;

    if (session.state && session.state === ChargingSessionState.InProgress) {
        consumedKwh = session.consumedWh ? Number(session.consumedWh.toFixed(2)) : 0
        chargingPrice = consumedKwh * (pricing ? Number(pricing.priceForKwh) : 0)
    } else {
        consumedKwh = session.consumedWh ? Number((session.consumedWh / 1000).toFixed(2)) : 0

        const now = new Date()

        if (session.startedParkingAt) {
            const startTime = new Date(session.startedParkingAt);
            if (!isNaN(startTime.getTime())) {
                const diffMs = now.getTime() - startTime.getTime();
                parkingTime = Math.floor(diffMs / 60000); // minutes

                // Apply free parking
                if (pricing?.amountOfFreeParking) {
                    parkingTime = Math.max(0, parkingTime - Number(pricing.amountOfFreeParking));
                }
            }
        }

        if (consumedKwh > 0 && pricing && Number(pricing.priceForKwh) > 0) {
            chargingPrice = consumedKwh * Number(pricing.priceForKwh)
        }
        if (parkingTime > 0 && pricing && Number(pricing.priceForMinuteOfParking) > 0) {
            parkingPrice = parkingTime * Number(pricing.priceForMinuteOfParking)
        }
    }

    return Number((chargingPrice + parkingPrice).toFixed(2))
}
